import { API_URL_CONFIG, ASSET_CONTAINER_NAME, ASSET_SAS_TOKEN, GEOSERVICE_API, ASSET_URL_CONFIG, isProduction } from "../../env";

export const environment = {
  production: isProduction,
  API_URL: API_URL_CONFIG, // 'https://devapi.dbraei.edu.in/api/v1/'
  ASSET_URL: ASSET_URL_CONFIG,
  ASSET_CONTAINER: ASSET_CONTAINER_NAME,
  GEOSERVICE_API: GEOSERVICE_API,
  API_URL_CONFIG: API_URL_CONFIG,
 ASSET_BLOB_URL: `${ASSET_URL_CONFIG}?${ASSET_SAS_TOKEN}`
};
